import bootbox from 'bootbox';

$(document).ready(function (e) {
    let $reports_to = $('#reports-to'),
        $master_checkbox = $('input[name="master"]'),
        $table_permissions = $('.table-permissions '),
        $role_permissions = $('.role-permissions');
    $('#master-group').on('change', function (e) {
        if ($(this).is(':checked')) {
            $reports_to.addClass('d-none');
            $master_checkbox.val(1);
            $table_permissions.addClass('d-none');
            $role_permissions.addClass('d-none');
        } else {
            $reports_to.removeClass('d-none');
            $master_checkbox.val(0);
            $table_permissions.removeClass('d-none');
            $role_permissions.removeClass('d-none');
        }
    });

    $('#delete-role').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-role-id');
        console.log(id);
        bootbox.confirm({
            message: "Are you sure you want to delete this role?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    window.location = `/settings/groups/delete/${id}`;
                }
            }
        });
    });

    $('.change-visibility').on('change', function (e) {
        let table_id = $(this).attr('data-table-id'),
            visibility = $(this).val();

        $.ajax({
            type: 'POST',
            url: '/settings/tables/visibility',
            data: {
                table_id: table_id,
                visibility: visibility,
            },
            success: function (res) {
                if (res) {
                    bootbox.alert("Table visibility set to " + (visibility === "0" ? 'private' : 'everyone'));
                }
            }
        });
    });

    $('.permission').on('change', handlePermissionsChange);
    $('.role-permission').on('change', handleRolePermissionsChange);

    if ($('#role-permissions').length) {
        handleRolePermissionsChange();
    }

    if ($('#table-permissions').length) {
        handlePermissionsChange();
    }

    if ($('#field-permissions').length) {
        handleFieldPermissionsChange();
    }

    if ($('#button-permissions').length) {
        handleButtonPermissionChange();
    }

    $('.change-field-permission').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).data('table-id');
        $('.field-permissions, .button-permissions').addClass('d-none');

        let $target = $('.field-permissions[data-table-id="' + table_id + '"]');

        if (!$target.hasClass('trans-loaded')) {
            $.ajax({
                type: 'GET',
                url: `/settings/table/${table_id}/translations`,
                success: function (data) {
                    Object.keys(data).forEach(function (key) {
                        $(`.tb-field[data-id="${key}"]`).text(data[key]);
                    });

                    $target.removeClass('d-none').addClass('trans-loaded');
                }
            })
        } else {
            $target.removeClass('d-none');
        }
    });

    $('.change-button-permission').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).data('table-id');
        $('.field-permissions, .button-permissions').addClass('d-none');
        $('.button-permissions[data-table-id="' + table_id + '"]').removeClass('d-none');
    });

    $('.select-permission').on('click', function (e) {
        e.preventDefault();
        let $selected = $(this),
            $dropdown = $selected.parents('.dropdown-menu'),
            $button = $($dropdown).siblings('.btn-default'),
            value = $(this).data('value');

        $($dropdown).find('.active').removeClass('active');
        $($selected).addClass('active');
        $($button).text(value);

        handleFieldPermissionsChange();
    });

    $('.select-btn-permission').on('change', function (e) {
        e.preventDefault();
        handleButtonPermissionChange();
    });

    $(document).on('change', 'select.mail-access-users', function (e) {
        let users = $(this).val(),
            account_id = $(this).attr('data-account-id');

        console.log('Changed');

        $.ajax({
            type: 'POST',
            url: '/settings/mail/access',
            data: {
                users,
                account_id
            },
            success: function (res) {

            }
        });
    })
});

function handleFieldPermissionsChange() {
    let $fields = $('.select-permission.active'),
        permissions = [];
    $fields.each(function (i, $permission) {
        let permission = {
            field_id: $($permission).data('field-id'),
            table_id: $($permission).data('table-id'),
            value: $($permission).data('permission'),
        };
        permissions.push(permission);
    });
    $('#field-permissions').val(JSON.stringify(permissions));
}

function handleButtonPermissionChange() {
    let $fields = $('.select-btn-permission'),
        permissions = [];
    $fields.each(function (i, $permission) {
        let permission = {
            button_id: $($permission).data('button-id'),
            table_id: $($permission).data('table-id'),
            value: $($permission).is(':checked') ? 1 : 0,
        };
        permissions.push(permission);
    });
    $('#button-permissions').val(JSON.stringify(permissions));
}

function handlePermissionsChange() {
    let $rows = $('.table-permissions').find('tbody > .permission-data'),
        permissions = [];

    $.each($rows, function (index, $row) {
        let $permissions = $($row).find('td > input'),
            table_id = $($row).attr('data-table-id'),
            permission = {};

        $.each($permissions, function (index, $permission) {
            permission[$($permission).attr('data-name')] = !!$($permission).is(':checked');
        });

        permissions.push({
            table_id: table_id,
            permissions: permission
        });
    });

    $('#table-permissions').val(JSON.stringify(permissions));
}

function handleRolePermissionsChange() {
    let $rows = $('.role-permissions').find('.role-permission'),
        permissions = {};

    $.each($rows, function (index, $row) {
        permissions[$($row).attr('data-name')] = !!$($row).is(':checked');
    });

    $('#role-permissions').val(JSON.stringify(permissions));
}